export default __webpack_public_path__ + "static/media/chocolate-cherry.bc36caf0.png";